import Common from '../../../../Common';

export type CustomerKeyValue = {
	id: id
	key: string
	value: string
}

const KeyValue = class extends Common {
	browse(companyId: id, userId: id) {
		return this.get(`/company/${companyId}/customerdata/userdata/${userId}/keyvalue`)
	}

	create(
		companyId: id,
		userId: id,
		data: {
			key: string,
			value: string,
		}
	) {
		return this.post(
			`/company/${companyId}/customerdata/userdata/${userId}/keyvalue`,
			data
		)
	}

	update = (companyId: id, userId: id, itemId: id, body: Omit<CustomerKeyValue, id>) =>
		this.patch(`/company/${companyId}/customerdata/userdata/${userId}/keyvalue/${itemId}`, body)

	delete = (companyId: id, userId: id, itemId: id) =>
		this.doDelete(`/company/${companyId}/customerdata/userdata/${userId}/keyvalue/${itemId}`);
}

export default KeyValue;
